if (!customElements.get('fabbricantti-stock')) {
  customElements.define('fabbricantti-stock', class extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-stock-variants]').textContent);
      this.form = document.getElementById(this.getAttribute('form-id'));
      this.onVariantChanged = (event) => this.update(event.detail.variant?.id);
      this.form?.addEventListener('variant:changed', this.onVariantChanged);
      this.update(this.form?.elements.namedItem('id')?.value || this.dataset.selectedVariant);
    }

    disconnectedCallback() {
      this.form?.removeEventListener('variant:changed', this.onVariantChanged);
    }

    update(variantId) {
      const variant = this.variants[String(variantId)];
      const rawQuantity = Number(variant?.quantity);
      this.hidden = !variant || !variant.tracked || !Number.isFinite(rawQuantity);
      if (this.hidden) return;
      const quantity = variant.available ? Math.max(rawQuantity, 0) : 0;
      const soldOut = !variant.available || quantity <= 0;
      const capacity = Math.max(Number(this.dataset.capacity) || 30, quantity, 1);
      const threshold = Number(this.dataset.lowThreshold);
      const lowStock = soldOut || quantity < threshold || (this.dataset.includeThreshold === 'true' && quantity === threshold);
      const message = lowStock
        ? (quantity === 1 ? this.dataset.messageOne : this.dataset.messageOther)
        : (quantity === 1 ? this.dataset.messageAvailableOne : this.dataset.messageAvailableOther);
      const text = soldOut ? this.dataset.messageSoldOut : message.replace('__COUNT__', String(quantity));
      this.dataset.variantId = String(variantId);
      this.classList.toggle('inventory--low', lowStock);
      this.querySelector('[data-stock-message]').textContent = text;
      const bar = this.querySelector('[data-stock-bar]');
      bar.setAttribute('aria-valuenow', String(quantity));
      bar.setAttribute('aria-valuemax', String(capacity));
      bar.setAttribute('aria-valuetext', text);
      bar.style.setProperty('--stock-fill', `${quantity / capacity * 100}%`);
    }
  });
}
